export default function toUTCTime(date, withMilli=false) {
	if (date === undefined || date === null){
	    date = new Date();
	}

	let res = date.getUTCFullYear() + "-" + (date.getUTCMonth() + 1) + "-" + date.getUTCDate() + " " + date.getUTCHours() + ":" + date.getUTCMinutes() + ":" + date.getUTCSeconds()
  if (withMilli) {
    res += "." + (date.getMilliseconds() * 1000)
  }
  return res
}


// WEBPACK FOOTER //
// ./src/App/helper/UTCtime.js